import React, { Component } from 'react';
import Modal from './Modal';
import check from "../../assets/check.svg";
import Cookies from 'js-cookie';
import equis from "../../assets/eliminar.svg";
import '../../css/FormAcuerdoAdmisiones.css';
import Header from './Header.js';
import Footer from './Footer.js';
import anuncioico from "../../assets/AnuncioICO.svg";
import jwt from 'jwt-decode'
import alarma from "../../assets/alarma.svg";
import AcuerdoAdmisiones from './AcuerdoAdmisiones.js';
import AcuerdoUsuariosExternos from './AcuerdoUsuarioExternos.js';

export class FormAcuerdoUsuariosExternos extends Component {
    constructor(props) {
        super(props);

        const token = Cookies.get("token");
        const identification = Cookies.get("identificacion")
        var tokendecode = jwt(token);

        this.state = {
          IsFirmado: false,
          modalError: false,
          isPersonalData: false,
          activebutton: true,
          modalIngresoDatos: false,
          aceptoAcuerdo: false,
          modalPrevAcuerdoGen: false,
          modalIsOpen: false,
          verBoton: true,
          datosUsuario: {
            identificacion: identification,
            nombres: tokendecode["Nombres"],
            apellidos: tokendecode["Apellidos"],
            correo: tokendecode["Email"],
            alias_sugerido: tokendecode["Email"],
            username: tokendecode["Email"],
            tipoIdentificacion: tokendecode["TipoIdentificacion"],
            fechaNacimiento: tokendecode["FechaNacimiento"],
            sexo: tokendecode["Sexo"],
          },
          navigateCas: false,
        };
        
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.abrirModalError = this.abrirModalError.bind(this);
    }

    cerrarModalError() {
        this.setState({
            modalError: false
        });
    }

    abrirModalError() {
        this.setState({
            modalError: true
        });
    }

    render() {
        return (
            !this.state.navigateCas ?
                this.state.IsFirmado ?
                    (<Modal isOpen={this.state.modalNoExisteEnBase} cerrarModal={this.cerrarModalnoExisteEnBase} verBoton={false} textoBoton="ACEPTAR" >
                        <div className='mt-6 mb-6 nacionalidad-modalnocuenta-div' align="center">
                            <img className="nacionalidad-modalnocuenta-logos" src={alarma} alt="Error"></img>
                        </div>
                        <p className='text-center nacionalidad-moadalnocuenta-texto '>Estimado usuario, usted ya ha firmado el <b>acuerdo de tratamiento de datos personales</b> para aspirantes a estudiantes de la ESPOL.</p>
                        <p className="text-center">
                            <strong>En el caso de existir un error, puede comunicarse con la unidad de Admisiones ESPOL.</strong></p>
                        <div className="text-center inactiva-contacto">
                            <table>
                                <tr>
                                    <td><strong>Atención: </strong></td>
                                    <td className="nacionalidad-centerTable">Lunes a Viernes de 08:30 a 16:00</td>
                                </tr>
                                <tr>
                                    <td><strong>Correo: </strong></td>
                                    <td className="nacionalidad-centerTable"><a href="mailto:admision@espol.edu.ec" >admision@espol.edu.ec</a></td>
                                </tr>
                            </table>
                        </div>
                    </Modal>)
                    :
                    (<AcuerdoUsuariosExternos
                        identificacion={this.state.datosUsuario.identificacion}
                        tipoIdentificacion={this.state.datosUsuario.tipoIdentificacion}
                        nombres={this.state.datosUsuario.nombres}
                        apellidos={this.state.datosUsuario.apellidos}
                        alias_sugerido={this.state.datosUsuario.alias_sugerido}
                        usuario_sugerido={this.state.datosUsuario.username}
                        correoAlterno={this.state.datosUsuario.correo}
                        password={this.state.datosUsuario.password}
                        fechaNacimiento={this.state.datosUsuario.fechaNacimiento}
                        sexo={this.state.datosUsuario.sexo}
                        tipoForm={"A"}
                        mensaje_titulo="Firma de acuerdo"
                        firmadoGeneral={true}
                        tipoAcuerdo={"Exterrnos"}
                        modalPrevAcuerdoGen={false}
                        useEffect={this.props.useEffect}
                    />)
                :
                this.state.modalError &&
                    <Modal isOpen={this.state.modalError} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>Error al cargar el acuerdo de admisiones ESPOL</strong></p>
                        <div align="center">
                            <img className="registroContra-check" src={equis} alt="Error"></img>
                        </div>
                        <p className='text-center'>Existe un problema en el token generado.</p>
                    </Modal>
        );
    }
}

export default FormAcuerdoUsuariosExternos;